import { FC, useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../hooks/redux'
import { useFirebaseOrderColors } from '../hooks/useFirebaseOrderColors'
import { selectLicense } from '../redux/reducers/license'
import { setStations } from '../redux/reducers/station/action-creators'
import AuthScreen from './AuthScreen'
import Digibon from './Digibon'

const MyApp: FC = () => {
    const license = useAppSelector(selectLicense)

    const dispatch = useAppDispatch()

    useFirebaseOrderColors()

    useEffect(() => {
        if (!license) return

        dispatch(setStations())
    }, [license, dispatch])

    if (!license) {
        return <AuthScreen />
    }

    return <Digibon />
}

export default MyApp
